/**
 * PortalGuard — auth wrapper for portal routes.
 * Redirects to portal login (preserving slug) if not authenticated.
 */

import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";

export function PortalGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    const loginPath = slug ? `/portal/${slug}/login` : "/portal/login";
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
